import { Box, Loader, Center } from '@mantine/core';

import { useGetReport } from '../../api/getReport';
import { LABELS } from '../../constants';
import { getTableData } from '../../utils/bot';

import { StatsTable } from './StatsTable/Table';

import { useGetProphetPages } from '@/features/prophet';
import { useDepartmentStore } from '@/stores/department';
import { Platforms } from '@/types';

type Props = {
  selectedDate: Date;
  platform: Platforms;
};

export const RequestsDataContent = ({ selectedDate, platform }: Props) => {
  const department = useDepartmentStore((state) => state.selected);

  const getProphetPages = useGetProphetPages({
    department,
    platform,
  });
  const pageIds = getProphetPages.data?.pages?.map((page) => page._id) || [];
  const getReport = useGetReport({
    pageIds,
    date: selectedDate,
    config: {
      enabled: !getProphetPages.isLoading && !!pageIds.length,
    },
  });
  const tableRows = getTableData(getProphetPages.data?.pages, getReport.data);

  if (getProphetPages.isLoading || (getReport.isLoading && pageIds.length > 0)) {
    return (
      <Center>
        <Loader m="xs" size="xl" />
      </Center>
    );
  }

  if (getProphetPages.error || getReport.error) {
    return <Center>{LABELS.DATA_LOAD_ERROR}</Center>;
  }

  if (!tableRows || tableRows.length === 0) {
    return <Center>{LABELS.NO_FILTER_DATA}</Center>;
  }

  return (
    <Box style={{ overflow: 'auto' }}>
      <StatsTable rows={tableRows} />
    </Box>
  );
};
